import { z } from "zod/v4";

import { StripeProductVersionList } from "../schemas/stripe";

import { StripeIntervalList, SubscriptionIntervalList } from "./subscriptions";

export const LivePriceDtoSchema = z.object({
  id: z.string(),
  priceIds: z.string().array(),
  interval: z.enum(StripeIntervalList),
  price: z.number(),
  comparePrice: z.number().nullish(),
  orderCountWithinLimit: z.boolean(),
  product: z.object({
    id: z.string(),
    name: z.string(),
    level: z.number().nullish().default(0),
    version: z.enum(StripeProductVersionList),
  }),
  features: z.string().array(),
});

export type LivePriceDto = z.infer<typeof LivePriceDtoSchema>;
